<template>
    <q-page padding>
        <q-tabs color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab default slot="title" name="news" :label="$t(title_news)" icon="fal fa-newspaper" />
            
            <q-tab-pane name="news">
                <div class="row gutter-md">
                    <div class="col-xs-12 col-sm-3">
                        <filter-news @changeFilter="changeFilter" />
                    </div>

                    <div class="col-xs-12 col-sm-9" style="min-height: 700px;">
                        <div class="col-xs-12 col-sm-12 q-ma-lg text-center" v-if="news.length == 0">
                            {{ $t('searched_term_returned_no_results') }}
                        </div>

                        <div else class="col-xs-12 col-sm-12">
                            <q-infinite-scroll :handler="getNews" :offset="500" ref="news_scroll">
                                <div class="row gutter-md">
                                    <div class="col-xs-12 col-sm-4" v-for="item in news" :key="item.id">
                                        <news-card :news="item" @showNews="showNews" />
                                    </div>
                                </div>
                            </q-infinite-scroll>
                        </div>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>

        <modal-notification  :show_modal="show_modal"  :id="id_news" @hideModalNews="hideModalNews" />
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import Filter from 'components/news/Filter'
const { formatDate } = date
import { required } from 'vuelidate/lib/validators'
import NewsFeed from 'components/news/NewsFeedCard'
import ModalNews from 'components/News'
import NewsCard from 'components/news/NewsCard'

export default {
    i18nOptions: { namespaces: ['custom', 'common', 'news'] },

    components: {
        'news-feed': NewsFeed,
        'modal-notification': ModalNews,
        'filter-news': Filter,
        'news-card': NewsCard
    },

    data() {
        return {
            count: 0,
            has_next_page: true,
            id_news: '',
            item: {},
            loading: false,
            news: [],
            news_loaded: false,
            order_by: {
                label: this.$t('last'),
                value: 'last'
            },
            page: 1,
            selected_areas: 'all',
            selected_search: '',
            selected_tags: [],
            show_modal: false
        }
    },

    computed: {
        ...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
            id_user_language_selected: 'common/id_user_language_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

		title_news(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_news == "" ? 'news' : obj.title_news
				}
			}
        }
       
    },

    methods: {
        getNews(index, done) {
            if (this.has_next_page) {
                this.$q.loading.show()

                let data = {
                    'page_size': 8,
                    'page': this.page,
                    'search': this.selected_search,
                    'ordering': this.order_by.value
                }

                if (this.selected_areas != 'all') data.areas = this.selected_areas
                if (this.selected_tags.length > 0) data.tags = this.selected_tags

                this.$axios.get(`/etraining_news/news/?${this.$qs.stringify(data, { arrayFormat: 'repeat' })}`, this.getHeader)
                .then(response => {
                    this.count = response.data.count
                    response.data.results.map(n =>  this.news.push({...n}))

                    if (!response.data.next) this.has_next_page = false
                    else this.page++
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                    done()
                })
            }
        },

        showNews(id) {
            this.id_news = id
            this.show_modal = true
        },

        openNews(e) {
            this.id_news = e.id
            this.show_modal = true
        },

        hideModalNews() {
            if(this.$route.params.id) this.$router.replace({ name: 'news' })
            this.show_modal = false
        },

        changeFilter(obj) {
            this.selected_areas = obj.areas
            this.selected_search = obj.search
            this.selected_tags = obj.tags
            this.news = []
            this.page = 1
            this.count = 0
            this.has_next_page = true

            if (this.$refs.news_scroll) {
                this.$refs.news_scroll.stop()
                this.$refs.news_scroll.resume()
                this.$refs.news_scroll.loadMore()
            }

        },
    }
}
</script>

<style>

</style>
